import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import {
  Navbar,
  Nav,
  NavDropdown,
  Image
} from "react-bootstrap";

import { logoutUser } from "actions/auth/actions";

import logo from "images/logo.png";

const Header = (props) => {
  const onLogoutClick = (ev) => {
    ev.preventDefault();
    props.logoutUser();
  };

  const sidebarToggle = (ev) => {
    ev.preventDefault();
    document.body.classList.toggle("sidebar-hidden");
  };

  /*
  const sidebarMinimize = (ev) => {
      ev.preventDefault();
      document.body.classList.toggle("sidebar-minimized");
  };
  */

  const mobileSidebarToggle = (ev) => {
    ev.preventDefault();
    document.body.classList.toggle("sidebar-mobile-show");
  };

  /*
  const asideToggle = (ev) => {
      ev.preventDefault();
      document.body.classList.toggle("aside-menu-hidden");
  };
  */

  const {
    isAuthenticated,
    user
  } = props.auth;

  const userName = user.sub ? user.sub : "Admin";
  const authLinks = (
    <Nav className="ml-auto">
      <NavDropdown
        title={userName}
        alignRight
        id="collasible-nav-dropdown"
      >
        <NavDropdown.Item onClick={onLogoutClick}>
          Logout
        </NavDropdown.Item>
      </NavDropdown>
    </Nav>
  );

  const guestLinks = (
    <Nav className="ml-auto">
      <Nav.Link href="/">Login</Nav.Link>
    </Nav>
  );

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      bg="light"
      className="px-5"
    >
      <div className="d-flex align-items-center">
        <Link
          to="/dashboard"
          className="navbar-brand"
        >
          <Image
            src={logo}
            style={{
              width: 100
            }}
          />
        </Link>
        <div className="d-lg-none" onClick={mobileSidebarToggle}>
          <span className="navbar-toggler-icon"/>
        </div>
      </div>
      <button type="button" className="d-md-down-none navbar-toggler">
        <span className="navbar-toggler-icon"/>
      </button>
      <div className="d-md-down-none" onClick={sidebarToggle}>
        <span className="navbar-toggler-icon"/>
      </div>

      <Navbar.Toggle aria-controls="responsive-navbar-nav"/>

      <Navbar.Collapse id="responsive-navbar-nav">
        {isAuthenticated ? authLinks : guestLinks}
      </Navbar.Collapse>
    </Navbar>
  );
};

Header.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
});

const mapStateToDispatch = dispatch => ({
  logoutUser: bindActionCreators(logoutUser, dispatch)
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Header);



// WEBPACK FOOTER //
// ./src/views/layout/header.js